var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('MomoNav', [_c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoRedeem'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_redeem.png")
    }
  })])], 1), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoRedeemRecord'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_redeem_record.png")
    }
  })])], 1), _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_point_record_active.png")
    }
  })])])]), _c('div', [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoMemberIndex'
      }
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("./images/momo_profile_back_btn.png")
    }
  })]), _c('img', {
    staticClass: "layoutMomo-title",
    attrs: {
      "src": require("./images/momo_title_point_record.png")
    }
  })], 1), _c('div', {
    staticClass: "records mt-3"
  }, [_vm._m(0), _c('div', {}, [_vm._l(_vm.pointLogs, function (pointLog) {
    return _c('div', {
      key: pointLog.id,
      staticClass: "record"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(pointLog.date))]), _c('div', {
      staticClass: "note"
    }, [_vm._v(_vm._s(pointLog.title))]), _c('div', {
      staticClass: "point"
    }, [_vm._v(_vm._s(pointLog.point))])]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.noMore,
      expression: "!noMore"
    }],
    staticClass: "button-loadmore text-center mt-3",
    on: {
      "click": function click($event) {
        !_vm.noMore && _vm.loadMore();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_load_more.png")
    }
  })])], 2)]), _vm._m(1)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "head d-flex"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("日期")]), _c('div', {
    staticClass: "note"
  }, [_vm._v("說明")]), _c('div', {
    staticClass: "point"
  }, [_vm._v("點數")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "records-tip"
  }, [_vm._v(" 點數依MOMO購物訂單實際消費金額給點"), _c('br'), _vm._v(" (扣除折價券或MO幣等折價後金額) ")]);
}]

export { render, staticRenderFns }